import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const MODALHEADERBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "display_close_icon"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  modalHeaderBlockDescriptor: _generatedModalHeaderBlockDescriptor,
  modalHeaderBlockBlocDefinition,
  modalHeaderBlockDashboardLayout,
  modalHeaderBlockConfig,
  modalHeaderBlockResolveConfig,
  modalHeaderBlockProperties,
} = doodBlockConfig(
  {
    name: "Modal header",
    componentType: 'ModalHeaderBlockComponent',
    category: 'navigation',
    description: "Modal header.",
    keywords: [],
    allowedIn: [
      { bloc: 'GenericModalComponent', slot: 'content' },
      { bloc: 'AuthenticationModalComponent', slot: 'signup_footer' },
    ],
    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.modal-header.heading.label",
      }
    }),
    display_close_icon: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.modal-header.display-close-icon.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.modal-header.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.modal-header.fieldset.header.label",
            fields: ["heading", "display_close_icon"],
          },
        ],
      },
    ],
  })
);

export function modalHeaderBlockDescriptor(): IBlockDescriptor;
export function modalHeaderBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function modalHeaderBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedModalHeaderBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedModalHeaderBlockDescriptor, modalHeaderBlockProperties, fieldOrder);
}

export {
  modalHeaderBlockBlocDefinition,
  modalHeaderBlockDashboardLayout,
  modalHeaderBlockProperties,
  modalHeaderBlockConfig,
  modalHeaderBlockResolveConfig,
};

export type ModalHeaderBlockConfig = typeof modalHeaderBlockConfig;
